import { Claim } from '@1po/1po-bff-fe-spec/generated/claim/response/model/Claim';
import { SupplierAttachmentsMessage } from '@1po/1po-bff-fe-spec/generated/claim/response/model/SupplierAttachmentsMessage';
import { SupplierComment } from '@1po/1po-bff-fe-spec/generated/claim/response/model/SupplierComment';
import { Disclosure } from 'components/Dialog';

export const ALL_DRAWER = 'ALL_DRAWER';
export const DOCUMENTS_DRAWER = 'DOCUMENTS_DRAWER';
export const COMMENT = 'COMMENT';
export const ATTACHMENT = 'ATTACHMENT';

export type TimelineType = typeof ALL_DRAWER | typeof DOCUMENTS_DRAWER;
export type TimelineItemType = typeof COMMENT | typeof ATTACHMENT;
export type SupplierAttachmentType = SupplierAttachmentsMessage['attachments'][number];

export interface TimelineItem {
  type: TimelineItemType;
  date: string;
  data: SupplierComment | SupplierAttachmentsMessage;
}

export interface ClaimDrawerProps {
  claim: Claim | null;
  disclosure: Disclosure;
  timelineType: TimelineType;
  onTimelineTypeChange: (type: TimelineType) => void;
}
